import { useSite, UI } from "@/lib/site";
import { Reveal, MaskLine } from "@/components/Reveal";

export const Steps = ({ steps }) => {
  const { t } = useSite();
  return (
    <section data-testid="steps-section" className="relative bg-[#f3eadb] px-5 py-24 md:px-10 md:py-36">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid gap-6 md:grid-cols-12">
          <p className="eyebrow md:col-span-3">{t(UI.stages)}</p>
          <h2 className="font-display text-4xl font-medium leading-[1.02] text-[#1d1712] sm:text-5xl lg:text-6xl md:col-span-9">
            <MaskLine inView>{t(UI.stages)}</MaskLine>
          </h2>
        </div>
        <ol className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {steps.map((s, i) => (
            <Reveal as="li" key={i} delay={(i % 3) * 0.1} className="group relative overflow-hidden rounded-[24px] border border-[#b8893b]/25 bg-[#fbf7ef] p-8 transition-[background-color,transform] duration-500 hover:-translate-y-1 hover:bg-[#1d1712] md:p-10" data-testid={`step-card-${i + 1}`}>
              <span className="font-display pointer-events-none absolute -right-2 -top-8 text-[9rem] leading-none text-[#b8893b]/10 transition-colors duration-500 group-hover:text-[#f0d78e]/15">{i + 1}</span>
              <p className="eyebrow transition-colors duration-500 group-hover:!text-[#f0d78e]">{t(UI.stage)} {String(i + 1).padStart(2, "0")}</p>
              <h3 className="font-display mt-5 text-3xl font-medium text-[#1d1712] transition-colors duration-500 group-hover:text-[#fbf3e2] md:text-4xl">{t(s.title)}</h3>
              <p className="mt-4 text-[0.95rem] leading-relaxed text-[#5b4f43] transition-colors duration-500 group-hover:text-[#d8ccb6]">{t(s.text)}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};

export const Stages = () => {
  const { t, content } = useSite();
  const stages = Array.isArray(content?.stages) ? content.stages : [];
  return (
    <section data-testid="stages-section" className="relative bg-[#f3eadb] px-5 py-24 md:px-10 md:py-36">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid gap-6 md:grid-cols-12">
          <p className="eyebrow md:col-span-3">{t(UI.stages)}</p>
          <h2 className="font-display text-4xl font-medium leading-[1.02] text-[#1d1712] sm:text-5xl lg:text-6xl md:col-span-9">
            <MaskLine inView>{t(UI.stages)}</MaskLine>
          </h2>
        </div>
        <div className="mt-16 grid gap-6 md:grid-cols-2 md:gap-8">
          {stages.map((s, i) => (
            <Reveal key={i} delay={i * 0.12} className="group relative overflow-hidden rounded-[26px] border border-[#b8893b]/25 bg-[#fbf7ef] p-8 transition-shadow duration-500 hover:shadow-[0_30px_60px_-30px_rgba(120,85,25,0.35)] md:p-12" data-testid={`stage-card-${i + 1}`}>
              <span className="font-display pointer-events-none absolute -right-4 -top-10 text-[11rem] leading-none text-[#b8893b]/10 transition-transform duration-700 group-hover:-translate-y-2">{i + 1}</span>
              <p className="eyebrow">{t(UI.stage)} {String(i + 1).padStart(2, "0")}</p>
              <h3 className="font-display mt-4 text-4xl font-medium text-[#1d1712] md:text-5xl">{t(s.title)}</h3>
              <p className="mt-4 max-w-md text-[0.95rem] leading-relaxed text-[#5b4f43]">{t(s.text)}</p>
              <ul className="mt-8 space-y-0">
                {(Array.isArray(s.items) ? s.items : []).map((it, k) => (
                  <li key={k} className="flex gap-4 border-t border-[#b8893b]/20 py-4 text-[0.95rem] text-[#2a2119]">
                    <span className="mt-0.5 text-xs font-semibold text-[#8a6424]">{String(k + 1).padStart(2, "0")}</span>
                    <span>{t(it)}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
